export default __webpack_public_path__ + "static/media/encart-promo-background-desktop.2c18fb78.jpg";